export const BOGE_FILTERS_STRINGS = 'boge-filters-strings';
export const BOGE_FILTERS_NUMBERS = 'boge-filters-numbers';
export const BOGE_FILTERS_ARRAYS = 'boge-filters-arrays';
export const BOGE_FILTERS_BOOLEANS = 'boge-filters-booleans';
